import { Category } from 'common/api/models';
import MenuContext from 'redux/menu/types/menuContext';
import SharedAssetContext from 'redux/menu/interfaces/sharedAssetContext';

const isSharedAssetContext = (context: MenuContext): context is SharedAssetContext =>
  context.kind === 'SHARED' && context.category === Category.AssetType;

export default isSharedAssetContext;
